function Footer({ onOpenContact }) {
  return (
    <footer className="vivo-footer">
      <div className="vivo-footer-links">
        <button type="button" className="vivo-footer-contact" onClick={onOpenContact}>
          Contact
        </button>
        <span>|</span>
        <a
          href="https://ca.linkedin.com/company/vivo-surgery"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <span>|</span>
        <a href="/privacy">Privacy</a>
        <span>|</span>
        <a href="/terms">Terms</a>
      </div>
      <p>© VivoSurgery {new Date().getFullYear()}. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
